"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Payment = void 0;

var Payment =
/** @class */
function () {
  function Payment() {}

  Payment.prototype.PurchaseErrorType = function () {
    return [{
      slug: 'card_declined',
      name: 'Your card was declined. Your request was in live mode, but used a known test card.',
      description: null,
      isCardDeclined: true,
      isCreditCardInvalid: false
    }, {
      slug: '2',
      name: 'Credit Card Invalid',
      description: 'The credit card number is invalid',
      isCardDeclined: false,
      isCreditCardInvalid: true
    }];
  };

  return Payment;
}();

exports.Payment = Payment;